<template>
  <div class="fill-width">
    <div v-if="!!label" class="text-body-2 mb-1">{{ label }}</div>
    <v-autocomplete
      v-model="value"
      filled
      rounded
      solo
      prepend-item="@/assets/icons/magnify.svg"
      :placeholder="placeholder"
      :item-text="itemText"
      :item-value="itemValue"
      :items="items"
      :rules="customRules ?? []"
      :no-data-text="noDataText"
    >
      <template v-slot:prepend-inner>
        <v-img src="@/assets/icons/magnify.svg" contain />
      </template>
    </v-autocomplete>
  </div>
</template>
<script>
export default {
  name: "custom-search",
  props: {
    label: {
      type: String,
      default: "",
    },
    itemText: {
      type: String,
      required: false,
    },
    itemValue: {
      type: String,
      required: false,
    },
    items: {
      type: Array,
      default: () => [],
    },
    customRules: {
      type: Array,
      default: () => [],
    },
    icon: {
      type: String,
      default: "",
    },
    noDataText: {
      type: String,
      default: "Nenhum resultado encontrado.",
    },
    placeholder: {
      type: String,
      default: "Buscar",
    },
    currentValue: null,
  },
  beforeMount() {
    if (this.currentValue) this.value = this.currentValue;
  },
  data() {
    return {
      value: null,
    };
  },
};
</script>
